import { render } from "./Assessments.vue?vue&type=template&id=95c766c8&scoped=true"
import script from "./Assessments.vue?vue&type=script&lang=js"
export * from "./Assessments.vue?vue&type=script&lang=js"

import "./Assessments.vue?vue&type=style&index=0&id=95c766c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c766c8"]])

export default __exports__